import React from "react";
import {
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    Button,
    Typography,
    Box,
    Avatar,
    Grid,
    Divider,
    Chip,
    IconButton
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import { styled } from "@mui/material/styles";
import { BASE_URL } from "../../Api/ApiUrls";

const StyledDialogTitle = styled(DialogTitle)({
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    backgroundColor: "#1976d2",
    color: "white",
});

const PropertyDetailItem = ({ label, value }) => (
    <Grid item xs={12} sm={6} md={4}>
        <Typography variant="subtitle1" gutterBottom sx={{ fontWeight: 'bold' }}>
            {label}:
        </Typography>
        <Typography variant="body1" gutterBottom color={value ? 'text.primary' : 'text.secondary'}>
            {value || "N/A"}
        </Typography>
    </Grid>
);

const Section = ({ title, children, show = true }) =>
    show ? (
        <Grid item xs={12} sx={{ mt: 2 }}>
            <Typography variant="subtitle1" sx={{ fontWeight: 'bold', mb: 1 }}>
                {title}
            </Typography>
            {children}
        </Grid>
    ) : null;

const ViewModal = ({ open, onClose, property }) => {
    if (!property) return null;

    const {
        property_images = [],
        power_backup,
        gated_security,
        borewell,
        parking,
        lift,
        _1bhk_count,
        _2bhk_count,
        _3bhk_count,
        _4bhk_count,
        bedrooms_count,
        bathrooms_count,
    } = property;

    const amenities = [
        { label: "Power Backup", value: power_backup },
        // { label: "Gated Security", value: gated_security },
        { label: "Borewell", value: borewell },
        { label: "Parking", value: parking },
        { label: "Lift", value: lift },
    ].filter(item => item.value);

    const roomConfigs = [
        { label: "1 BHK", value: _1bhk_count },
        { label: "2 BHK", value: _2bhk_count },
        { label: "3 BHK", value: _3bhk_count },
        { label: "4 BHK", value: _4bhk_count },
        { label: "Bedrooms", value: bedrooms_count },
        { label: "Bathrooms", value: bathrooms_count },
    ].filter(item => item.value);

    return (
        <Dialog open={open} onClose={onClose} maxWidth="md" fullWidth>
            <StyledDialogTitle>
                <Typography variant="h6">{property.property_name || "Property Details"}</Typography>
                <IconButton onClick={onClose} sx={{ color: "white" }}>
                    <CloseIcon />
                </IconButton>
            </StyledDialogTitle>

            <DialogContent dividers>
                <Typography variant="h6" gutterBottom sx={{ color: 'primary.main' }}>
                    Property Details
                </Typography>

                <Divider sx={{ my: 2 }} />

                <Grid container spacing={3}>
                    <PropertyDetailItem label="Property Name" value={property.property_name} />
                    {/* <PropertyDetailItem label="Type" value={property.type} /> */}
                    <PropertyDetailItem label="Price" value={property.price ? `₹${property.price.toLocaleString()}` : null} />
                    <PropertyDetailItem label="Location" value={property.location} />
                    <PropertyDetailItem label="Facing" value={property.facing} />
                    <PropertyDetailItem label="Road Width" value={property.roadwidth ? `${property.roadwidth} ${property.units}` : null} />
                    <PropertyDetailItem label="Site Area" value={property.site_area ? `${property.site_area} ${property.units}` : null} />
                    <PropertyDetailItem label="Dimensions" value={property.length && property.width ? `${property.length} x ${property.width} ${property.units}` : null} />
                    <PropertyDetailItem label="Built-up Area" value={property.buildup_area ? `${property.buildup_area} ${property.units}` : null} />
                    {/* <PropertyDetailItem label="Posted By" value={property.posted_by} /> */}
                    {/* <PropertyDetailItem label="Nearby" value={property.nearby} /> */}
                    <PropertyDetailItem label="Mobile No" value={property.mobile_no} />
                    {/* <PropertyDetailItem label="Coordinates" value={property.lat && property.long ? `Lat: ${property.lat}, Long: ${property.long}` : null} /> */}

                    <Section title="Amenities" show={amenities.length > 0}>
                        <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 1 }}>
                            {amenities.map((item, idx) => (
                                <Chip key={idx} label={`${item.label}: ${item.value}`} />
                            ))}
                        </Box>
                    </Section>

                    <Section title="Room Configuration" show={roomConfigs.length > 0}>
                        <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 1 }}>
                            {roomConfigs.map((item, idx) => (
                                <Chip key={idx} label={`${item.label}: ${item.value}`} />
                            ))}
                        </Box>
                    </Section>

                    <Section title="Property Images" show={property_images.length > 0}>
                        <Box sx={{ display: 'flex', gap: 2, overflowX: 'auto', py: 2 }}>
                            {property_images.map((image) => (
                                <Avatar
                                    key={image.id}
                                    src={`${BASE_URL}${image.image}`}
                                    alt={`Property ${image.id}`}
                                    variant="rounded"
                                    sx={{ width: 150, height: 150 }}
                                />
                            ))}
                        </Box>
                    </Section>
                </Grid>
            </DialogContent>

            <DialogActions>
                <Button onClick={onClose} color="primary" variant="contained">
                    Close
                </Button>
            </DialogActions>
        </Dialog>
    );
};

export default ViewModal;
